import { combineReducers } from 'redux'
//import ScrumBoardReducer from './ScrumBoardReducer'
import NotificationReducer from './NotificationReducer'
//import EcommerceReducer from './EcommerceReducer'
import NavigationReducer from './NavigationReducer'
import UserSettingReducer from './UserSettingReducer'
import WorkerReducer from './WorkerReducer'
import UtilsReducer from './UtilsReducer'
import MeasurementRuleReducer from './MeasurementRuleReducer'
import ReportRuleReducer from './ReportRuleReducer'
import LabolinkReducer from './LabolinkReducer'
import AnalyzerDateTimeReducer from './AnalyzerDateTimeReducer'

const RootReducer = combineReducers({
    notifications: NotificationReducer,
    navigations: NavigationReducer,
    //scrumboard: ScrumBoardReducer,
    //ecommerce: EcommerceReducer,
    usersetting: UserSettingReducer,
    worker: WorkerReducer,
    utils: UtilsReducer,
    rules: MeasurementRuleReducer,
    report: ReportRuleReducer,
    labolink: LabolinkReducer,
    analyzer: AnalyzerDateTimeReducer,
})

export default RootReducer
